import { API, graphqlOperation } from "aws-amplify";
import { createMonitor, deleteMonitor, updateMonitor } from "graphql/mutations";
import {
  ChatData,
  ChatDataType,
  CreateMonitorInput,
  DeleteMonitorInput,
  GetMonitorQuery,
  ListChatDataSortBySortIndexQuery,
  ListMonitorSortByAnsIdQuery,
  ModelSortDirection,
  Monitor,
  UpdateMonitorInput,
} from "types/graphqlapi";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { getMonitor, listMonitorSortByAnsId } from "graphql/queries";

export const getMonitorByIdQuery = async (monitorId: string) => {
  const result = (await API.graphql(
    graphqlOperation(getMonitor, {
      id: monitorId,
    })
  )) as {
    data: GetMonitorQuery;
  };

  const object = result.data.getMonitor as Monitor;

  return object;
};

/**
 * 同一案件のモニターリストを取得
 * @param subjectId
 * @returns
 */
export const fetchMonitorBysubjectIdQuery = async (subjectId: string) => {
  let list: Monitor[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listMonitorSortByAnsId, {
        subject_id: subjectId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListMonitorSortByAnsIdQuery;
    };
    const data = result.data.listMonitorSortByAnsId;
    const items = (data?.items || []) as Monitor[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list.sort((a, b) =>
    a.sort_index && b.sort_index
      ? a.sort_index > b.sort_index
        ? 1
        : -1
      : Number(a.ans_id) > Number(b.ans_id)
      ? 1
      : -1
  );
};

const listChatDataSortBySortIndex = /* GraphQL */ `
  query ListChatDataSortBySortIndex(
    $interview_id: ID
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listChatDataSortBySortIndex(
      interview_id: $interview_id
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        type
        monitor_id
        createdAt
      }
      nextToken
    }
  }
`;

export const listLastMonitorSentDateListQuery = async (
  interviewId: string,
  monitorList: Monitor[]
): Promise<
  {
    monitor_id: string;
    createdAt: string;
  }[]
> => {
  try {
    const monitorMap = new Map();
    let nextToken;
    do {
      const result = (await API.graphql(
        graphqlOperation(listChatDataSortBySortIndex, {
          interview_id: interviewId,
          sortDirection: ModelSortDirection.DESC,
          limit: 100,
          nextToken,
        })
      )) as {
        data: ListChatDataSortBySortIndexQuery;
      };

      const resultData = result?.data?.listChatDataSortBySortIndex
        ?.items as ChatData[];

      if (resultData.length > 0) {
        const monitorSentList = resultData.filter(
          (chat) => chat.monitor_id && chat.type !== ChatDataType.SYSTEMLOG
        );

        monitorSentList.reduce((map, chat) => {
          const existingItem = map.get(chat.monitor_id);
          if (!existingItem) {
            map.set(chat.monitor_id, chat.createdAt);
          }
          return map;
        }, monitorMap);
      }

      nextToken = result?.data?.listChatDataSortBySortIndex?.nextToken;
    } while (monitorList.length > monitorMap.size && nextToken);

    return Array.from(monitorMap).map((item) => {
      return { monitor_id: item[0], createdAt: item[1] };
    });
  } catch (e) {
    console.error(e);
    throw e;
  }
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createMonitorMutation = async (
  createMonitorInput: CreateMonitorInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createMonitor, {
      input: createMonitorInput,
    })
  )) as GraphQLResult<{ createMonitor: Monitor }>;

  return result;
};

/**
 * 更新
 * @param
 * @returns 更新されたデータ
 */
export const updateMonitorMutation = async (
  updateMonitorInput: UpdateMonitorInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateMonitor, { input: updateMonitorInput })
  )) as GraphQLResult<{ updateMonitor: Monitor }>;

  return result;
};

/**
 * 特定のデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteMonitorMutation = async (
  deleteMonitorInput: DeleteMonitorInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteMonitor, {
      input: deleteMonitorInput,
    })
  )) as GraphQLResult<{ deleteMonitor: Monitor }>;

  return result;
};
